module.exports = __webpack_public_path__ + "static/media/30.921962c7.jpg";